import { connect } from 'dva';
import { userRoleInCurrentProject } from '../../selectors/app';
import Roles from '../../utils/roles';

function WithHideCompanyPermissions({ children, app }) {
  const role = userRoleInCurrentProject(app);

  const hasPermissions = () => {
    return [
      Roles.role_super_admin.id,
      Roles.role_admin.id,
      Roles.role_editor.id,
    ].includes(role);
  };

  if (hasPermissions()) {
    return children;
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
  };
};

export default connect(mapStateToProps)(WithHideCompanyPermissions);



// WEBPACK FOOTER //
// ./src/components/Permissions/WithHideCompanyPermissions.js